import React from 'react'

export const WhatsUpSvg = ({ size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="20" cy="20" r="20" fill="#00E676" fillRule="nonzero" />
      <path
        fill="#FFF"
        d="M25.363 22.27c-.297-.147-1.753-.86-2.025-.959-.271-.098-.469-.147-.666.148-.198.295-.766.96-.939 1.156-.172.197-.345.221-.642.074-.296-.148-1.25-.46-2.382-1.463-.88-.782-1.475-1.748-1.648-2.043-.173-.295-.019-.455.13-.602.133-.132.296-.344.444-.516.148-.173.198-.296.296-.492.1-.197.05-.37-.024-.517-.074-.148-.667-1.599-.914-2.19-.24-.574-.485-.496-.666-.505-.173-.009-.37-.01-.568-.01-.198 0-.519.073-.79.368-.272.295-1.037 1.009-1.037 2.46s1.061 2.853 1.21 3.05c.148.197 2.089 3.175 5.06 4.452.708.304 1.26.486 1.69.621.71.225 1.355.193 1.866.117.569-.084 1.753-.713 2-1.402.246-.689.246-1.279.172-1.402-.074-.123-.271-.197-.567-.344m-5.406 7.345h-.004c-1.769 0-3.503-.473-5.016-1.367l-.36-.212-3.73.973.995-3.619-.234-.37c-.986-1.562-1.507-3.367-1.507-5.22.003-5.408 4.423-9.808 9.86-9.808 2.632.001 5.106 1.023 6.967 2.876 1.86 1.854 2.885 4.319 2.884 6.94-.002 5.407-4.423 9.807-9.855 9.807m8.387-18.155C26.106 9.23 23.13 8 19.957 8 13.42 8 8.102 13.293 8.099 19.8c0 2.08.545 4.11 1.583 5.899L8 31.814l6.286-1.641c1.731.94 3.681 1.435 5.666 1.436h.005c6.535 0 11.854-5.294 11.857-11.8.001-3.153-1.231-6.118-3.47-8.348"
      />
    </g>
  </svg>
)
